import { defineComponent as _defineComponent } from 'vue'
import PlantDetail from "@/components/plant/PlantDetail.vue"


const __default__ = {
  name: "PlantPage"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
    required: true
  }
},
  setup(__props, { expose }) {
  expose();



const __returned__ = { PlantDetail }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})